/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * ########################################
 * Init Number Counter
 * ########################################
 */
import 'countup.js';

jQuery(document).ready(function($) {

    $('.number-counter').waypoint({
        handler: function() {
            $('.count-item').each(function(i) {

                var count_val = $(this).data('count');
                var $this = $(this);

                $({countNum: $this.text()}).animate({countNum: count_val}, {
                    duration: 2000,
                    easing:'linear',
                    step: function() {
                        $this.text(Math.floor(this.countNum));
                    },
                    complete: function() {
                        $this.text(this.countNum);
                    }
                });
            });
        },
        offset: '100%'
    });

});

